export default "__VITE_ASSET__DtBpoEg1__"